export const ADD_MERCHANT = gql`
    mutation AddMerchantApplication($input: AddMerchantApplicationInput) {
        addMerchantApplication(input: $input) {
            id
            serviceRequirements
            merchantInformation
            outletInformation
            businessInformation
            supportingDocuments
            partnerId
            isServiceApplication
            status
            partner {
                countryDetails {
                    alpha2Code
                }
            }
            trialPeriod
        }
    }
`;

export const UPDATE_MERCHANT_PRINCIPALS = gql`
    mutation UpdateMerchantPrincipals($input: UpdateMerchantPrincipalsInput) {
        updateMerchantPrincipals(input: $input) {
            fullName
        }
    }
`;
